import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import MandatoryInput from '../../common/components/layout/MandatoryInput';
import {GRAPHQL_MUTATION_RESET_ACCOUNT_PASSWORD} from '../../common/queries/users';
import {Mutation} from 'react-apollo';
import Error from '../../common/components/Error/Error';
import {PulseLoader} from 'react-spinners';
import {Col, Container, Row} from 'react-bootstrap';
import {checkPasswordsMatch, validatePassword} from '../../utils';
import LoginButton from '../../common/components/LoginButton';

const ResetPasswordForm = ({t, token, setReset}) => {
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  return (
    <Mutation mutation={GRAPHQL_MUTATION_RESET_ACCOUNT_PASSWORD} variables={{token, password}} onCompleted={() => setReset(true)}>
      {(resetPassword, {error, loading}) => {
        return (
          <Row>
            <Col xs={{span: 10, offset: 1}} md={{span: 10, offset: 1}} lg={{span: 4, offset: 4}} className="inputs-block">
              <div className="login-title">{t('resetPass.title')}</div>
              <Container>
                <Row>
                  <Col xs={{span: 10, offset: 1}}>
                    <Container>
                      <Row>
                        <React.Fragment>
                          <Error error={error} />
                          <div className="spaced-input">
                            <MandatoryInput
                              name="password"
                              type="password"
                              title={t('reg.form.field.pass')}
                              value={password}
                              onChange={(name, text) => {
                                setPassword(text);
                                setPasswordsMatch(checkPasswordsMatch(passwordConfirmation, text) || passwordConfirmation === '');
                                setSubmitted(false);
                              }}
                              show={(submitted && password === '') || (password !== '' && !validatePassword(password))}
                              customText={!validatePassword(password) && t('reg.invalidPassword')}
                            />
                          </div>
                          <div className="spaced-input">
                            <MandatoryInput
                              name="confirmPassword"
                              type="password"
                              title={t('reg.form.field.passConf')}
                              value={passwordConfirmation}
                              onChange={(name, text) => {
                                setPasswordConfirmation(text);
                                setPasswordsMatch(checkPasswordsMatch(password, text));
                                setSubmitted(false);
                              }}
                              show={(submitted && passwordConfirmation === '') || !passwordsMatch}
                              customText={!passwordsMatch && t('reg.passwordsMatch')}
                            />
                          </div>
                          {loading ? (
                            <PulseLoader />
                          ) : (
                            <LoginButton onClick={() => {
                              setSubmitted(true);
                              if (password !== '' && passwordConfirmation !== '' && passwordsMatch && validatePassword(password)) {
                                resetPassword();
                              }
                            }}>
                              {t('resetPass.form.btnSubmit')}
                            </LoginButton>
                          )}
                        </React.Fragment>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        );
      }}
    </Mutation>
  );
};

ResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  values: PropTypes.object,
  onSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation('login')(ResetPasswordForm);
